import {FeatureAppDefinition, FeatureServices, Logger} from '@feature-hub/core';
import {ReactFeatureApp} from '@feature-hub/react';
import React from 'react';
import {App} from './app';
import {FeatureServicesContext} from './use-feature-services';
import dependencies from './dependencies.json';
import {HistoryServiceV2} from '@feature-hub/history-service';
import {ApiKeyProviderV1} from '@volkswagen-onehub/api-key-provider';
import {DisclaimerManagerV1} from '@volkswagen-onehub/disclaimer-manager';
import {FaContentServiceV1} from '@volkswagen-onehub/fa-content-service';
import {LayerManagerV24} from '@volkswagen-onehub/layer-manager';
import {LocaleServiceV1} from '@volkswagen-onehub/locale-service';
import {ServiceConfigProviderV1} from '@volkswagen-onehub/service-config-provider';
import {PageInfoServiceV1} from '@volkswagen-onehub/page-info-service';
import {BreadcrumbServiceV1} from '@volkswagen-onehub/breadcrumb-service';
import {ThemeProvider} from '@volkswagen-onehub/components-core';
import { TrackingManagerV1 } from '@volkswagen-onehub/tracking-service';
import {
  CommonFeatureAppConfig,
  initializeFetchJson,
} from '@volkswagen-onehub/vw-starter-feature-app-support';
import { TimelineContext } from './store/context/TimelineContext';
import { AppContext, FeatureAppConfig } from './store/context/AppContext';

export interface StarterFeatureAppDependencies extends FeatureServices {
  readonly 'api-key-provider'?: ApiKeyProviderV1;
  readonly 'disclaimer-manager': DisclaimerManagerV1;
  readonly 'fa-content-service'?: FaContentServiceV1;
  readonly 'layer-manager': LayerManagerV24;
  readonly 'locale-service': LocaleServiceV1;
  readonly 's2:history': HistoryServiceV2;
  readonly 's2:logger'?: Logger;
  readonly 'service-config-provider': ServiceConfigProviderV1;
  readonly 'page-info-service': PageInfoServiceV1;
  readonly 'breadcrumb-service': BreadcrumbServiceV1;
  readonly 'tracking': TrackingManagerV1;
}

export const featureAppDefinition: FeatureAppDefinition<
  ReactFeatureApp,
  StarterFeatureAppDependencies,
  CommonFeatureAppConfig
> = {
  ...dependencies,

  create: (env) => {
    const {config, featureServices} = env;

    const {
      's2:logger': logger = console
    } = featureServices;

    // initialize the mock server and mock ids
    initializeFetchJson('starter', logger, config);

    return {
      // eslint-disable-next-line react/display-name
      render: () => {
        return (
          <AppContext.Provider value={config as FeatureAppConfig}>
            <FeatureServicesContext.Provider value={featureServices}>
              <ThemeProvider theme="main">
                <TimelineContext>
                  <App />
                </TimelineContext>
              </ThemeProvider>
            </FeatureServicesContext.Provider>
          </AppContext.Provider>
        );
      },
    };
  },
};

export default featureAppDefinition;
